import {
  DynamicTextStatus,
  type TDynamicTextsFromSearch,
} from 'models/common.model'
import type { TDynamicTextsEventProperties } from 'models/events.model'

const DYNAMIC_TEXT_STATUS_SEVERITY = [
  DynamicTextStatus.REJECTED,
  DynamicTextStatus.VALIDATED,
  DynamicTextStatus.APPLIED,
]

const getStatusToReport = ({
  headline,
  subtext,
  plan,
}: TDynamicTextsFromSearch): DynamicTextStatus | undefined => {
  const statuses = [headline.status, subtext.status, plan.status]

  return DYNAMIC_TEXT_STATUS_SEVERITY.find((status) =>
    statuses.includes(status),
  )
}

export const getDynamicTextsEventProperties = (
  dynamicTexts: TDynamicTextsFromSearch,
  isDynamicHeadlinesTestGroup: boolean,
): TDynamicTextsEventProperties => {
  const { headline, subtext, plan } = dynamicTexts

  const status = getStatusToReport(dynamicTexts)

  const areDynamicTextsShown =
    isDynamicHeadlinesTestGroup &&
    Boolean(headline.text || subtext.text || plan.text)

  return {
    query_headline: headline.text,
    query_subtext: subtext.text,
    query_plan: plan.text,
    dynamic_texts_enabled: areDynamicTextsShown,
    ...(status && { dynamic_texts_status: status }),
  }
}
